export type ChartColor = 'bg-teacher-blue' | 'bg-chart-light-blue' | 'bg-chart-purple' | 'bg-chart-pink' | 'bg-chart-yellow';

export const groupResultsChartColors: ChartColor[] = ['bg-chart-purple', 'bg-chart-pink', 'bg-chart-yellow', 'bg-chart-light-blue', 'bg-teacher-blue'];

export const parentInvolvementChartColors: ChartColor[] = ['bg-chart-purple', 'bg-chart-yellow', 'bg-teacher-blue'];
